import React from 'react';
import PropTypes from 'prop-types';
import {renderPreviewContent} from '@/utils/rewardsDisplay';
import {useAppSelector} from '@/store';

/**
 * RewardPreview component displays preview text based on reward type and form data
 */
const RewardPreview = ({
  formData,
  contentClassName = '',
  renderOnlyText = false
}) => {
  const countryCode = useAppSelector((state) => state.countryCode)?.countryCode;
  const previewText = renderPreviewContent({formData, countryCode});

  // Don't render anything if there's no preview content
  if (!previewText) {
    return null;
  }

  if (renderOnlyText) {
    return <p className={contentClassName}>{previewText}</p>;
  }

  return (
    <div className='mt-4'>
      <p className='text-sm text-white'>
        <span className='font-bold'>Preview:</span> {previewText}
      </p>
    </div>
  );
};

RewardPreview.propTypes = {
  formData: PropTypes.shape({
    rewardType: PropTypes.string,
    selectedProducts: PropTypes.array,
    orderQuantity: PropTypes.string,
    points: PropTypes.string
  }).isRequired,
  contentClassName: PropTypes.string,
  renderOnlyText: PropTypes.bool
};

export default RewardPreview;
